import request from '@/utils/request'
import https from '@/utils/https.js'
export function getList(rank_type,page) {
    return https({
        url: '/api/school_rank/get_list',
        method: 'post',
        data: {
            rank_type: rank_type,
            page: page
        }
    })
}

// export function getCategoryList() {
//     return https({
//         url: '/api/school_rank/get_list',
//         method: 'post',
//         data: {}
//     })
// }
export function getCategoryList() {
    return https({
        url: 'api/special_rank/getCategory',
        method: 'post',
        data: {}
    })
}
export function getEvaluationList(spec_cate_id) {
    return https({
        url: '/api/special_rank/getEvaluationList',
        method: 'post',
        data: {
            spec_cate_id: spec_cate_id
        }
    })
}